module.exports = __webpack_public_path__ + "static/media/german_bf109_120.99ae4b2d.png";